__webpack_require__.p = "https://demo.inventory.boolanga.com/";